// Mock data for LMP PINTURAS website

export const services = [
  {
    id: 1,
    title: "Bate Chapas",
    description: "Reparação completa de amassados e riscos na lataria do veículo. Recuperamos a estrutura original com precisão e qualidade.",
    icon: "Wrench",
    features: ["Reparação de amassados", "Correção de riscos", "Restauração de lataria", "Trabalho de precisão"]
  },
  {
    id: 2,
    title: "Pintura Automotiva",
    description: "Pintura completa ou parcial do carro, com escolha de cor e aplicação de verniz de alta qualidade para acabamento perfeito.",
    icon: "Paintbrush",
    features: ["Pintura completa", "Pintura parcial", "Aplicação de verniz", "Acabamento premium"]
  },
  {
    id: 3,
    title: "Embarcações",
    description: "Serviços especializados de pintura e reparação para embarcações, com produtos resistentes ao ambiente marítimo.",
    icon: "Ship",
    features: ["Pintura náutica", "Proteção anti-corrosão", "Reparação de fibra", "Acabamento especializado"]
  }
];

export const galleryImages = {
  carros: [
    {
      id: 1,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/efokayhn_foto1.jpg"
    },
    {
      id: 2,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/uecn6rdy_~2.jpg"
    },
    {
      id: 3,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/ruhjokxg_3.jpg"
    },
    {
      id: 4,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/d74km25m_9.jpg"
    },
    {
      id: 5,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/q3gjq6qx_98.jpg"
    },
    {
      id: 6,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/e2vo6ywa_WhatsApp%20Image%202026-02-22%20at%2013.01.05%20%281%29.jpeg"
    },
    {
      id: 7,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/3w50e18h_WhatsApp%20Image%202026-02-22%20at%2013.01.05.jpeg"
    },
    {
      id: 8,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/sfbjcvor_WhatsApp%20Image%202026-02-22%20at%2013.01.06%20%281%29.jpeg"
    },
    {
      id: 9,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/wuii0qfa_WhatsApp%20Image%202026-02-22%20at%2013.01.06.jpeg"
    },
    {
      id: 10,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/nqv75826_WhatsApp%20Image%202026-02-22%20at%2013.01.12%20%281%29.jpeg"
    },
    {
      id: 11,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/pibifwak_WhatsApp%20Image%202026-02-22%20at%2013.01.12%20%282%29.jpeg"
    },
    {
      id: 12,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/pkqvqm1f_WhatsApp%20Image%202026-02-22%20at%2013.01.12%20%283%29.jpeg"
    },
    {
      id: 13,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/eq00o6um_WhatsApp%20Image%202026-02-22%20at%2013.01.12%20%284%29.jpeg"
    },
    {
      id: 14,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/652hhi31_WhatsApp%20Image%202026-02-22%20at%2013.01.12%20%285%29.jpeg"
    },
    {
      id: 15,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/coms1ppt_WhatsApp%20Image%202026-02-22%20at%2013.01.13.jpeg"
    },
    {
      id: 16,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/ro5epmx3_WhatsApp%20Image%202026-02-22%20at%2013.01.14%20%281%29.jpeg"
    },
    {
      id: 17,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/p9cxli4s_WhatsApp%20Image%202026-02-22%20at%2013.01.14%20%282%29.jpeg"
    },
    {
      id: 18,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/xkq9oern_WhatsApp%20Image%202026-02-22%20at%2013.01.14.jpeg"
    },
    {
      id: 19,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/j2ig1037_WhatsApp%20Image%202026-02-22%20at%2013.01.15%20%281%29.jpeg"
    },
    {
      id: 20,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/l80g0aj1_WhatsApp%20Image%202026-02-22%20at%2013.01.23%20%281%29.jpeg"
    },
    {
      id: 21,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/j7dm9jhz_WhatsApp%20Image%202026-02-22%20at%2013.01.23%20%282%29.jpeg"
    },
    {
      id: 22,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/ra4jnz4j_WhatsApp%20Image%202026-02-22%20at%2013.01.23%20%283%29.jpeg"
    },
    {
      id: 23,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/f3216tfp_WhatsApp%20Image%202026-02-22%20at%2013.01.23%20%284%29.jpeg"
    },
    {
      id: 24,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/i8hgwf94_WhatsApp%20Image%202026-02-22%20at%2013.01.23%20%286%29.jpeg"
    }
  ],
  embarcacoes: [
    // Motorhomes/Caravanas
    {
      id: 25,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/1fke969g_WhatsApp%20Image%202026-02-22%20at%2013.01.13%20%282%29.jpeg"
    },
    {
      id: 26,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/t58ufap5_WhatsApp%20Image%202026-02-22%20at%2013.01.22.jpeg"
    },
    {
      id: 27,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/sne6yzs3_597648031_122269856954194433_5905059066424986907_n.jpg"
    },
    {
      id: 28,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/ijvg0dmz_WhatsApp%20Image%202026-02-22%20at%2013.01.13%20%281%29.jpeg"
    },
    // Iate de luxo - Primeira série
    {
      id: 29,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/gsbwxmbb_IMG_20210414_153003.jpg"
    },
    {
      id: 30,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/8e3dafpt_IMG_20210414_153024.jpg"
    },
    {
      id: 31,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/gqkkgauy_IMG_20210530_100514.jpg"
    },
    {
      id: 32,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/p4am9lhn_IMG_20210530_100649.jpg"
    },
    {
      id: 33,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/hfkumczd_IMG_20210609_144905.jpg"
    },
    // Iate de luxo - Segunda série (novas fotos)
    {
      id: 34,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/nhglht0l_IMG_20210202_124951.jpg"
    },
    {
      id: 35,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/wz9xixca_IMG_20210409_141641.jpg"
    },
    {
      id: 36,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/ne0wtj1l_IMG_20210618_170503.jpg"
    },
    {
      id: 37,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/d5eblvn4_IMG_20210805_093508.jpg"
    },
    {
      id: 38,
      url: "https://customer-assets.emergentagent.com/job_limpeza-pinturas/artifacts/zfezymfn_IMG_20210805_100339.jpg"
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Carlos Silva",
    location: "Faro",
    rating: 5,
    comment: "Excelente trabalho! Meu carro ficou como novo. Profissionalismo e qualidade impecável.",
    date: "2024-11"
  },
  {
    id: 2,
    name: "Ana Costa",
    location: "Loulé",
    rating: 5,
    comment: "Recomendo sem dúvidas. Equipa muito profissional e preço justo. O meu Range Rover ficou perfeito!",
    date: "2024-10"
  },
  {
    id: 3,
    name: "Miguel Santos",
    location: "Quarteira",
    rating: 5,
    comment: "Melhor oficina de pintura da região. Trabalho impecável e entrega no prazo.",
    date: "2024-12"
  }
];

export const workingHours = [
  { day: "Segunda-feira", hours: "07:00 - 18:00", open: true },
  { day: "Terça-feira", hours: "07:00 - 18:00", open: true },
  { day: "Quarta-feira", hours: "07:00 - 18:00", open: true },
  { day: "Quinta-feira", hours: "07:00 - 18:00", open: true },
  { day: "Sexta-feira", hours: "07:00 - 13:00", open: true },
  { day: "Sábado", hours: "Fechado", open: false },
  { day: "Domingo", hours: "Fechado", open: false }
];

export const companyInfo = {
  name: "LMP PINTURAS",
  tagline: "Auto e Náutica",
  slogan: "Pintamos paixões, protegemos investimentos",
  description: "LMP PINTURAS é uma empresa especializada em serviços de bate chapas, pintura automotiva e náutica. Com anos de experiência no mercado, destacamo-nos pelo comprometimento em oferecer serviços de alta qualidade e excelência aos nossos clientes.",
  phone: "963 241 522",
  phoneFormatted: "+351 963 241 522",
  whatsapp: "+351963241522",
  address: "Estr. da Estação, 8100-000 Loulé",
  location: {
    city: "Loulé",
    country: "Portugal"
  }
};

// Mock function to simulate quote request submission
export const submitQuoteRequest = async (quoteData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  console.log("Quote request submitted:", quoteData);
  
  // Simulate success response
  return {
    success: true,
    message: "Pedido de orçamento recebido! Entraremos em contato em breve.",
    quoteId: `ORÇ-${Date.now()}`
  };
};

// Mock function to simulate contact form submission
export const submitContactForm = async (contactData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log("Contact form submitted:", contactData);
  
  return {
    success: true,
    message: "Mensagem enviada com sucesso! Responderemos em breve."
  };
};
